import Vue from "vue";
import App from "./App.vue";
import axios from "axios";
import router from "./router";
import Argon from "./plugins/argon-kit";
import './registerServiceWorker'
import VueCarousel from 'vue-carousel';
import VueAlertify from 'vue-alertify';
import VueNumberInput from '@chenfengyuan/vue-number-input';
import moment from "moment";
import VueSmoothScroll from 'vue2-smooth-scroll';
import * as VueGoogleMaps from "vue2-google-maps";
import VModal from 'vue-js-modal';


Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyDDTfz1ZuaYp23TPEauyLi0la4CgEe4aSw",
    //libraries: "places" // necessary for places input
  }
});



Vue.use(VueNumberInput);
Vue.use(VueCarousel);
Vue.config.productionTip = false;
Vue.use(Argon);
Vue.use(axios);
Vue.use(VModal);
Vue.use(VueSmoothScroll, {
    duration: 720,
    updateHistory: false,
})
Vue.use(VueAlertify, {
    // notifier defaults
    notifier: {
        // auto-dismiss wait time (in seconds)
        delay: 5,
        // default position
        position: 'bottom-center',
        // adds a close button to notifier messages
        closeButton: true,
    },
})

Vue.filter('formatDate', function (value) {
    if (value) {
        return moment(String(value)).format('DD MMM YYYY')
    }
});

Vue.filter('striphtml', function (value) {
    var div = document.createElement("div");
    div.innerHTML = value;
    var text = div.textContent || div.innerText || "";
    return text.substring(0,150)+"..";
  });

  Vue.filter('csvtags', function (value) {
    var div = document.createElement("div");
    div.innerHTML = "";
    var mytext = "";
    var stringArr = value.split(',');
    var h = 0;
    for (let i = 0; i < stringArr.length; i++) {
        const single = stringArr[i];
        if(h < 4) {
            mytext += "<li class='amtag'>"+single+"</li>";        
        }
        if(h == 4) {
            mytext += "<li class='amtag2'> & more...</li>";        
        }
        h++;
    }
     div.innerHTML = mytext;
     var text = div.textContent || div.innerText || "";
    return mytext;
  });

new Vue({
    router,
    render: h => h(App)
}).$mount("#app");